import { Gift, Tag } from '@wix/wix-ui-icons-common/lazy';
import { useIsMobile } from '@wix/core-domain-search';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { BaseVoucherBanner } from './VoucherBanner';
import { Box } from '@wix/design-system';
const CONTENT_KEYS = {
  voucher: {
    desktop: 'domains_search_gate.base44.gate.promo_banner.voucher',
    mobile: 'domains_search_gate.base44.gate.mobile.promo_banner.voucher'
  },
  noVoucher: {
    desktop: 'domains_search_gate.base44.gate.promo_banner.no_voucher',
    mobile: 'domains_search_gate.base44.gate.mobile.promo_banner.no_voucher'
  }
};
export const Base44VoucherBanner = () => {
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  const isMobile = useIsMobile();
  const {
    data,
    isLoading
  } = DomainsApiClient.hooks.useDomainsAccount({});
  if (isLoading) {
    return null;
  }
  const hasVoucher = !!(data != null && data.hasValidVouchers);
  const keys = hasVoucher ? CONTENT_KEYS.voucher : CONTENT_KEYS.noVoucher;
  return /*#__PURE__*/React.createElement(BaseVoucherBanner, {
    icon: /*#__PURE__*/React.createElement(Box, {
      alignSelf: "start"
    }, hasVoucher ? /*#__PURE__*/React.createElement(Gift, null) : /*#__PURE__*/React.createElement(Tag, null)),
    content: t(isMobile ? keys.mobile : keys.desktop),
    background: "linear-gradient(90deg, #EBFFB1 0%, #EBFFB1 100%)"
  });
};
//# sourceMappingURL=Base44VoucherBanner.js.map